/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {VehicleDirectionDefinition} from "../../model/VehicleDirectionDefinition";
import {NgxSpinnerService} from "ngx-spinner";
import {VehicleDirectionDefinitionService} from "../../services/vehicle-direction-definition.service";
import {NgForm} from "@angular/forms";
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-vehicle-direction',
    templateUrl: './vehicle-direction.component.html',
    styleUrls: ['./vehicle-direction.component.less'],
    standalone: false
})
export class VehicleDirectionComponent extends BaseMessageComponent implements OnInit {
  @ViewChild('documentEditForm') documentEditForm: ElementRef;
  public vehicleDirections: VehicleDirectionDefinition[];

  constructor(private spinnerService: NgxSpinnerService,
              private vehicleDirectionService: VehicleDirectionDefinitionService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllVehicleDirection();
  }

  private getAllVehicleDirection(){
    this.spinnerService.show();
    this.vehicleDirectionService.getAll().subscribe(value => {
        this.vehicleDirections = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        //this.loading=false;
        this.spinnerService.hide();
      }
    );
  }

  private getChangedIndex(f:NgForm): number[] {
    let changedIndexes = [];

    Object.keys(f.controls).forEach((name) => {
      let currentControl = f.controls[name];

      if (currentControl.dirty){
        let UIindex = +name.substr(name.indexOf('__')+2);

        changedIndexes.push(UIindex);
      }

    });

    return changedIndexes;
  }

  addNew(newDirection: string, newDesc: string){
    this.spinnerService.show();
    var newVehicleDirection = new VehicleDirectionDefinition();
    newVehicleDirection.vehicleDirection = newDirection;
    newVehicleDirection.vehicleDirectionDesc = newDesc;

    this.vehicleDirectionService.addVehicleDirection(newVehicleDirection).subscribe(retVal=>{
      this.getAllVehicleDirection();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident crash object finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var vehicleDirectionIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (vehicleDirectionIds!=null && vehicleDirectionIds.length>0)
    {
      vehicleDirectionIds.forEach(vdi=>{
        var vehicleDirectionChanged = this.vehicleDirections.find(x=>x.vehicleDirectionDefinitionId === vdi);
        this.vehicleDirectionService.updateVehicleDirectionById(vehicleDirectionChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllVehicleDirection();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=vehicleDirectionIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllVehicleDirection();
    this.returnMessage = 'Updating accident crash object finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
